export default __webpack_public_path__ + "static/media/CV_TRON_Frederic.b3272d44.pdf";